const escapeAttribute = (value) => String(value).replace(/&/g, "&amp;").replace(/\"/g, "&quot;");

export const buildPrintableDocument = (markup, stylesheetHrefs = [], title = "Subscription Invoice") => {
  const links = stylesheetHrefs
    .filter(Boolean)
    .map((href) => `<link rel="stylesheet" href="${escapeAttribute(href)}">`)
    .join("");

  return `<!doctype html>
<html>
  <head>
    <meta charset="utf-8">
    <title>${escapeAttribute(title).replace(/</g, "&lt;").replace(/>/g, "&gt;")}</title>
    ${links}
    <style>
      @media print { body { margin: 0; } }
      body { background: #fff; color: #000; }
      .invoice-print-actions { display: none !important; }
    </style>
  </head>
  <body>${markup}</body>
</html>`;
};

const waitForImages = (printDocument) => {
  const images = Array.from(printDocument.images || []);
  if (!images.length) return Promise.resolve();

  return Promise.all(images.map((image) => {
    if (image.complete) return Promise.resolve();
    return new Promise((resolve) => {
      const done = () => {
        image.removeEventListener?.("load", done);
        image.removeEventListener?.("error", done);
        resolve();
      };
      image.addEventListener?.("load", done);
      image.addEventListener?.("error", done);
      setTimeout(done, 2000);
    });
  }));
};

const printInCurrentWindow = () => {
  if (typeof window.print !== "function") throw new Error("Printing is unavailable.");
  window.print();
  return true;
};

export const printInvoiceNode = async (node, { title = "Subscription Invoice" } = {}) => {
  if (!node) throw new Error("Invoice content is unavailable.");

  const popup = typeof window.open === "function"
    ? window.open("", "_blank", "width=900,height=700")
    : null;
  if (!popup) return printInCurrentWindow();

  try {
    const stylesheetHrefs = Array.from(
      document.querySelectorAll('link[rel="stylesheet"]'),
    ).map((link) => link.href || link.getAttribute("href"));
    popup.document.open();
    popup.document.write(buildPrintableDocument(node.outerHTML, stylesheetHrefs, title));
    popup.document.close();
    await waitForImages(popup.document);
    popup.focus?.();
    if (typeof popup.print !== "function") throw new Error("Printing is unavailable.");
    popup.print();
    popup.close?.();
    return true;
  } catch (error) {
    popup.close?.();
    throw error;
  }
};
